import ListPageService from 'src/types/ListPage';
import OriginalMessage from '../originalMessage';
import OriginalMessageApi, {OriginalMessageDOI} from '../api/originalMessageApi'
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import override from 'src/dectorators/override';
import Input from 'src/types/iview/Input';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import DatePicker from 'src/types/iview/DatePicker';

export default class OriginalMessageService extends ListPageService {
    ctx: OriginalMessage

    constructor(ctx: OriginalMessage) {
        super();
        this.ctx = ctx;
    }


    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        let ctx = t.ctx;
        return [
            {
                headerName: '报文详情',
                field: 'data',
                minWidth: 10000,
            },
        ]
    }


    @override
    creatQueryForm(): QueryFormVOI.DateItemType[]{
        return [
            {
                component: Input,
                labelWidth: 20,
                label: 'cn',
                field: 'cn',
                props: { value: '2011', placeholder: '请输入cn' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: 'pw',
                field: 'pw',
                props: { value: '123456', placeholder: '请输入pw' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: 'mn',
                field: 'mn',
                props: { value: '', placeholder: '请输入mn' },
            },
            {
                component: DatePicker,
                label: '时间',
                field: 'datatime',
                width: 250,
                props: { value:  new Date(), type: 'date', format: 'yyyy-MM-dd', placeholder: '请选择时间', clearable: false },
            },
        ];
    }
    
    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<OriginalMessageDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }
    
    @override
    async searchTable() {
        let t = this;
        let ctx = this.ctx;
        let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
        ag.showLoading();
        let { code, data } = await OriginalMessageApi.getOriginalMessage({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();
        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}